import { Link } from "react-router-dom";
import { money } from "./format";
import { priceInfo, badgeFor, productColours } from "./shopData";
import { CountdownShort } from "./Countdown";
import { useStore } from "./StoreContext";

export default function ProductCard({ product: p, eager = false }) {
  const { refresh } = useStore();
  const price = priceInfo(p);
  const badge = badgeFor(p);
  const [first, second] = p.images;
  const colours = productColours(p);
  return (
    <Link to={`/merch/${p.slug}`} className={`sh-card${p.inStock || p.teased ? "" : " is-out"}${p.teased ? " is-teased" : ""}`}>
      <div className="sh-card-media">
        {first ? (
          <img src={first.url} alt={first.alt || p.title} loading={eager ? "eager" : "lazy"} decoding="async" className="sh-card-img" />
        ) : (
          <span className="sh-card-noimg">{p.title}</span>
        )}
        {second && !p.teased && <img src={second.url} alt="" loading="lazy" decoding="async" className="sh-card-img sh-card-img-alt" aria-hidden="true" />}
        {badge && <span className={`sh-badge sh-badge-${badge.kind}`}>{badge.text}</span>}
        {p.teased && (
          <span className="sh-card-drop">
            <span>Drops in</span> <CountdownShort to={p.launchAt} onDone={refresh} />
          </span>
        )}
      </div>
      <div className="sh-card-body">
        <h3 className="sh-card-title">{p.title}</h3>
        <p className="sh-card-price">
          {price.from && <span className="sh-from">from </span>}
          <span className={price.was ? "sh-price-now" : ""}>{money(price.min)}</span>
          {price.was && <s>{money(price.was)}</s>}
        </p>
        {colours.length > 1 && (
          <span className="sh-card-swatches" aria-label={`${colours.length} colours`}>
            {colours.slice(0, 5).map((c) => (
              <i key={c.value} style={c.hex ? { background: c.hex } : undefined} title={c.value} />
            ))}
          </span>
        )}
      </div>
    </Link>
  );
}
